export const OTP_CONFIG = {
  LENGTH: 6,
  TIMER_DURATION: 60, // seconds
} as const;

